import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../components/footer/footer.component';
import { StaticSearchComponent } from '../../../components/static-search/static-search.component';
import { CommonHeaderComponent } from '../../../components/common-header/common-header.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { environment } from '../../../../environments/environment';
import { PDSService } from '../../../services/pds.service';

@Component({
  selector: 'app-basics-cover',
  standalone: true,
  imports: [
    FooterComponent,
    StaticSearchComponent,
    CommonHeaderComponent,
    CommonModule,
  ],
  templateUrl: './basics-cover.component.html',
  styleUrl: './basics-cover.component.scss',
})
export class BasicsCoverComponent implements OnInit {
  sanitizedHtml: SafeHtml | null = null;
  partnerCode: string = '';
  constructor(
    public pdsService: PDSService,
    private sanitizer: DomSanitizer,
    private titleService: Title,
    private metaService: Meta,
  ) {
    this.titleService.setTitle(
      'Basic International Travel & Holiday Insurance | World2Cover',
    );
    this.metaService.updateTag({
      name: 'description',
      content:
        'World2Cover offers basic travel insurance and holiday insurance to help suit your budget. Get cover online for your next trip.',
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Basic International Travel & Holiday Insurance | World2Cover',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content:
        'World2Cover offers basic travel insurance and holiday insurance to help suit your budget. Get cover online for your next trip.',
    });
  }

  ngOnInit(): void {
    let href: string = '';
    this.partnerCode = this.pdsService.getWhiteLabelPartnerCode();
    switch (environment.autoClub.toUpperCase()) {
      case 'W2C':
        href = `<a target="_blank" href="${
          this.partnerCode === 'Klook' || this.partnerCode === 'vacatio'
            ? `/whitelabelpds?partnerCode=${this.partnerCode}`
            : '/policydocumentation'
        }">here</a>`;
        this.sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(href);
        break;
      case 'RACV':
      case 'RACQ':
      case 'RACT':
      case 'RAA':
      case 'RAC':
      case 'AANT':
        this.loadPdsLinkForOtherClubs();
        break;
    }
  }

  loadPdsLinkForOtherClubs() {
    this.pdsService.getLatestPDS().subscribe((data) => {
      const href = `<a rel="noopener noreferrer" target="_blank" href="${
        data && data.pds && data.pds.length > 0 ? data.pds[0].previewUrl : '#'
      }">here</a>`;
      this.sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(href);
    });
  }
}
